"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toGeometry = exports.toFeature = exports.toFeatureCollection = void 0;
const types_1 = require("../types");
function toFeatureCollection(features) {
    return {
        type: types_1.FEATURE_COLLECTION_TYPE,
        features,
    };
}
exports.toFeatureCollection = toFeatureCollection;
function toFeature(geometry, properties) {
    return {
        type: types_1.FEATURE_TYPE,
        geometry,
        properties: properties || null,
    };
}
exports.toFeature = toFeature;
function toGeometry(type, coordinates) {
    return {
        type,
        coordinates,
    };
}
exports.toGeometry = toGeometry;
//# sourceMappingURL=index.js.map